<div class="modal-backdrop" (click)="onBackdropClick()"></div>
<dialog #drawerElement class="native-drawer" [open]="true">
  <div class="drawer-container">
    <div class="drawer-handle"></div>

    @if (config().title || config().icon) {
      <div class="drawer-header">
        @if (config().icon) {
          <div class="drawer-icon">
            <mat-icon [style.color]="config().iconColor || '#1976d2'">{{ config().icon }}</mat-icon>
          </div>
        }
        @if (config().title) {
          <h3>{{ config().title }}</h3>
        }
      </div>
    }

    <div class="drawer-content">
      @if (config().message) {
        <p>{{ config().message }}</p>
      }
    </div>

    <div class="drawer-actions">
      @for (action of config().actions; track action) {
        <button
          mat-button
          [color]="action.color || 'primary'"
          [attr.mat-raised-button]="action.variant === 'raised' ? '' : null"
          [attr.mat-stroked-button]="action.variant === 'stroked' ? '' : null"
          [attr.mat-flat-button]="action.variant === 'flat' ? '' : null"
          (click)="onActionClick(action.action)"
          class="drawer-action-button">
          {{ action.text }}
        </button>
      }
    </div>
  </div>
</dialog>
